import styled from 'styled-components';
import { TPaymentPeriod as TReportingHistoryItemProps } from '../../types/payment-data-types';
import { ReportingHistoryItemContainer, ReportingHistoryItemDateLabel } from './styles';

const NotYetReportedContainer = styled.div.attrs({
  className: 'reportingHistoryNotYetReported'
})`
  display: flex;
  justify-content: center;
  padding: 10px 0;
`;

export function EmptyReportingPeriod(props: TReportingHistoryItemProps) {
  return (
    <ReportingHistoryItemContainer>
      <ReportingHistoryItemDateLabel>{props.label}</ReportingHistoryItemDateLabel>
      <NotYetReportedContainer>Not yet reported</NotYetReportedContainer>
    </ReportingHistoryItemContainer>
  )
}
